export default __webpack_public_path__ + "navigation-examples-beta-query-parameters-1200-684f948c9d8ddf914af291c50d551237.webp";